import {
  getCustomer,
  openSubscribeModal,
} from "../services/api/customerAndSubscriptionHelpers";
import { calculateTrialDaysLeft } from "./calculateTrialDaysLeft";
import { isFeatureEnabled } from "./featureFlag"; // Remove after successful launch

export const checkAuthorizationAndSubscription = async (t) => {
  const token = await t.get("member", "private", "token");
  if (!token || token.includes("rejected")) {
    // Return Auth modal if the user is not yet authorized
    await t.modal({
      title: "",
      accentColor: "#1064E3",
      url: "./authorize.html",
      height: 593,
      args: { trigger: "show-authorization" },
    });
    return false;
  } else {
    // Remove after successful launch (start)
    if (!(await isFeatureEnabled({ t }))) {
      // If the subscription feature is not enabled, let the user through
      return true;
    }
    // Remove after successful launch (end)

    const { stripeSubscriptionStatus, earlyAdopter, createdDate } =
      await getCustomer(t);
    const trialDaysLeft = calculateTrialDaysLeft(createdDate);
    const activeSubscription = stripeSubscriptionStatus === "active";
    if (!activeSubscription && !earlyAdopter && trialDaysLeft <= 0) {
      // If the user is not subscribed and the trial has ended, open the subscribe modal
      await openSubscribeModal(t);
      return false;
    }
  }
  return true;
};
